<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button :class="b('', { view })" :disabled="disabled">
    <slot />
    <span v-if="label">{{ $t(label) }}</span>
  </button>
</template>
